/* ==========================================================================
   Vizion Concepts – total price in the Add to Cart button
   Shows the selected variant's price plus whatever the YMQ Product Options
   add-ons cost ("Selection will add $X to the price"), e.g. "ADD TO CART · $478.95".

   The variant is read from the form's [name="id"] field rather than the theme's
   variantChange event: YMQ's own Bike Size dropdown sets that field directly
   without telling the theme, so this script also passes it on to the theme.
   ========================================================================== */
(function () {
  var TOTAL = '[data-vc-atc-total]';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function scopeFor(el) {
    return el.closest('.product-section') || document;
  }

  // "id:price,id:price" -> price of the variant currently in the form
  function variantCents(el) {
    var form = el.closest('form');
    var idField = form && form.querySelector('[name="id"]');
    var id = idField && idField.value;
    var pairs = (el.getAttribute('data-variant-prices') || '').split(',');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split(':');
      if (pair[0] === id) return parseInt(pair[1], 10) || 0;
    }
    return parseInt(el.getAttribute('data-base-price'), 10) || 0;
  }

  // YMQ shows #ymq-price-addons only while a paid option is selected
  function addonCents(scope) {
    var box = scope.querySelector('#ymq-price-addons');
    if (!box || box.style.display === 'none') return 0;
    var money = box.querySelector('#ymq-addons-price [data-ymq-money]');
    var amount = money ? parseFloat(money.getAttribute('data-ymq-money')) : NaN;
    return isNaN(amount) ? 0 : Math.round(amount * 100);
  }

  // YMQ's Bike Size dropdown only sets the form's variant id. Push that variant into the
  // theme's own (hidden) option inputs so the theme updates the title price, sale price
  // and sold-out state as if the customer had used them.
  function variantsFor(scope) {
    if (scope._vcVariants === undefined) {
      var json = scope.querySelector('[data-variant-json]');
      try {
        scope._vcVariants = json ? JSON.parse(json.value || json.textContent) : null;
      } catch (e) {
        scope._vcVariants = null;
      }
    }
    return scope._vcVariants;
  }

  function syncThemeVariant(scope) {
    var form = scope.querySelector('form.product-single__form');
    var idField = form && form.querySelector('[name="id"]');
    var variants = variantsFor(scope);
    if (!idField || !variants) return;

    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === idField.value) variant = variants[i];
    }
    if (!variant) return;

    var changed = null;
    scope.querySelectorAll('[data-variant-input]').forEach(function (input) {
      var value = variant[input.getAttribute('data-index')];
      if (value === undefined || value === null) return;
      var type = input.getAttribute('type');
      if (type === 'radio' || type === 'checkbox') {
        if (input.value === value && !input.checked) {
          input.checked = true;
          changed = input;
        }
      } else if (input.value !== value) {
        input.value = value;
        changed = input;
      }
    });
    if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function update(scope) {
    syncThemeVariant(scope);
    scope.querySelectorAll(TOTAL).forEach(function (el) {
      var amountEl = el.querySelector('[data-vc-atc-total-amount]');
      var text = formatMoney(variantCents(el) + addonCents(scopeFor(el)));
      if (amountEl && amountEl.textContent !== text) amountEl.textContent = text;
    });
  }

  function watch(scope) {
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      // Wait a frame so YMQ / the theme have finished updating the form and add-on box
      requestAnimationFrame(function () {
        queued = false;
        update(scope);
      });
    }
    new MutationObserver(schedule).observe(scope, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'data-ymq-money', 'selected']
    });
    // Option changes that only touch input values, not the DOM
    scope.addEventListener('change', schedule, true);
    scope.addEventListener('input', schedule, true);
    scope.addEventListener('click', schedule, true);
    update(scope);
  }

  function init() {
    var scopes = [];
    document.querySelectorAll(TOTAL).forEach(function (el) {
      var scope = scopeFor(el);
      if (scopes.indexOf(scope) === -1) scopes.push(scope);
    });
    scopes.forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
